import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Zap, ArrowLeft } from 'lucide-react';

const ConfidentialitePage = () => {
  return (
    <div style={{backgroundColor: '#F7F8FA', color: '#1e293b'}} className="min-h-screen">
      {/* Navigation */}
      <nav style={{backgroundColor: '#ffffff'}} className="border-b border-slate-200 sticky top-0 z-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <Link to="/" className="flex items-center space-x-2">
              <div className="w-9 h-9 bg-gradient-to-br from-blue-600 to-indigo-600 rounded-xl flex items-center justify-center">
                <Zap className="h-5 w-5 text-white" />
              </div>
              <span style={{color: '#1e293b'}} className="text-xl font-bold">SmartFacture AI</span>
            </Link>
            <Link to="/">
              <Button variant="ghost" style={{color: '#475569'}}>
                <ArrowLeft className="h-4 w-4 mr-2" />
                Retour
              </Button>
            </Link>
          </div>
        </div>
      </nav>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 style={{color: '#1e293b'}} className="text-3xl font-bold mb-8">Politique de Confidentialité</h1>
        
        <div style={{backgroundColor: '#ffffff'}} className="rounded-2xl p-8 shadow-sm space-y-8">
          
          <section>
            <h2 style={{color: '#1e293b'}} className="text-xl font-semibold mb-4">1. Introduction</h2>
            <p style={{color: '#475569'}}>
              SmartFacture AI s'engage à protéger la vie privée de ses utilisateurs. Cette politique de confidentialité 
              explique comment nous collectons, utilisons, stockons et protégeons vos données personnelles 
              conformément au Règlement Général sur la Protection des Données (RGPD).
            </p>
          </section>

          <section>
            <h2 style={{color: '#1e293b'}} className="text-xl font-semibold mb-4">2. Responsable du traitement</h2>
            <div style={{color: '#475569'}} className="space-y-2">
              <p><strong>SmartFacture AI</strong></p>
              <p>Email : contact@smartfacture-ai.com</p>
              <p>Site : https://smartfacture-ai.com</p>
            </div>
          </section>

          <section>
            <h2 style={{color: '#1e293b'}} className="text-xl font-semibold mb-4">3. Données collectées</h2>
            <p style={{color: '#475569'}}>Nous collectons les données suivantes :</p>
            <ul style={{color: '#475569'}} className="list-disc ml-6 mt-2 space-y-1">
              <li><strong>Données d'identification :</strong> nom, prénom, email, mot de passe (chiffré)</li>
              <li><strong>Données professionnelles :</strong> nom d'entreprise, SIREN, SIRET, numéro TVA, adresse</li>
              <li><strong>Données de facturation :</strong> factures créées, clients, montants</li>
              <li><strong>Données techniques :</strong> adresse IP, type de navigateur, pages visitées</li>
              <li><strong>Données de paiement :</strong> traitées par notre prestataire Stripe (nous ne stockons pas vos coordonnées bancaires)</li>
            </ul>
          </section>

          <section>
            <h2 style={{color: '#1e293b'}} className="text-xl font-semibold mb-4">4. Finalités du traitement</h2>
            <p style={{color: '#475569'}}>Vos données sont utilisées pour :</p>
            <ul style={{color: '#475569'}} className="list-disc ml-6 mt-2 space-y-1">
              <li>Fournir et améliorer notre service de facturation</li>
              <li>Gérer votre compte et vos abonnements</li>
              <li>Vous envoyer des notifications relatives à votre compte</li>
              <li>Répondre à vos demandes de support</li>
              <li>Respecter nos obligations légales</li>
              <li>Établir des statistiques anonymes d'utilisation</li>
            </ul>
          </section>

          <section>
            <h2 style={{color: '#1e293b'}} className="text-xl font-semibold mb-4">5. Base légale du traitement</h2>
            <ul style={{color: '#475569'}} className="list-disc ml-6 space-y-1">
              <li><strong>Exécution du contrat :</strong> création de compte, fourniture du service</li>
              <li><strong>Consentement :</strong> envoi de communications marketing</li>
              <li><strong>Intérêt légitime :</strong> amélioration du service, sécurité</li>
              <li><strong>Obligation légale :</strong> conservation des factures, lutte contre la fraude</li>
            </ul>
          </section>

          <section>
            <h2 style={{color: '#1e293b'}} className="text-xl font-semibold mb-4">6. Durée de conservation</h2>
            <ul style={{color: '#475569'}} className="list-disc ml-6 space-y-1">
              <li><strong>Données de compte :</strong> durée de l'abonnement + 3 ans</li>
              <li><strong>Factures :</strong> 10 ans (obligation légale comptable)</li>
              <li><strong>Données techniques :</strong> 1 an</li>
              <li><strong>Données de paiement :</strong> selon les obligations de Stripe</li>
            </ul>
          </section>

          <section>
            <h2 style={{color: '#1e293b'}} className="text-xl font-semibold mb-4">7. Partage des données</h2>
            <p style={{color: '#475569'}}>
              Vos données peuvent être partagées avec :
            </p>
            <ul style={{color: '#475569'}} className="list-disc ml-6 mt-2 space-y-1">
              <li><strong>Stripe :</strong> traitement des paiements</li>
              <li><strong>Resend :</strong> envoi d'emails transactionnels</li>
              <li><strong>OpenAI :</strong> traitement IA pour le scanner (données anonymisées)</li>
              <li><strong>Hébergeur :</strong> stockage sécurisé des données</li>
            </ul>
            <p style={{color: '#475569'}} className="mt-2">
              Nous ne vendons jamais vos données à des tiers.
            </p>
          </section>

          <section>
            <h2 style={{color: '#1e293b'}} className="text-xl font-semibold mb-4">8. Sécurité des données</h2>
            <p style={{color: '#475569'}}>
              Nous mettons en œuvre des mesures de sécurité appropriées :
            </p>
            <ul style={{color: '#475569'}} className="list-disc ml-6 mt-2 space-y-1">
              <li>Chiffrement des données en transit (HTTPS/TLS)</li>
              <li>Chiffrement des mots de passe (bcrypt)</li>
              <li>Authentification sécurisée (JWT)</li>
              <li>Accès restreint aux données</li>
              <li>Sauvegardes régulières</li>
            </ul>
          </section>

          <section>
            <h2 style={{color: '#1e293b'}} className="text-xl font-semibold mb-4">9. Vos droits</h2>
            <p style={{color: '#475569'}}>
              Conformément au RGPD, vous disposez des droits suivants :
            </p>
            <ul style={{color: '#475569'}} className="list-disc ml-6 mt-2 space-y-1">
              <li><strong>Accès :</strong> obtenir une copie de vos données</li>
              <li><strong>Rectification :</strong> corriger vos données inexactes</li>
              <li><strong>Effacement :</strong> demander la suppression de vos données</li>
              <li><strong>Limitation :</strong> limiter le traitement de vos données</li>
              <li><strong>Portabilité :</strong> recevoir vos données dans un format structuré</li>
              <li><strong>Opposition :</strong> vous opposer au traitement de vos données</li>
            </ul>
            <p style={{color: '#475569'}} className="mt-2">
              Pour exercer ces droits, contactez-nous à : <strong>contact@smartfacture-ai.com</strong>
            </p>
          </section>

          <section>
            <h2 style={{color: '#1e293b'}} className="text-xl font-semibold mb-4">10. Cookies</h2>
            <p style={{color: '#475569'}}>
              Pour en savoir plus sur notre utilisation des cookies, consultez notre{' '}
              <Link to="/cookies" className="text-blue-600 hover:underline">Politique de Cookies</Link>.
            </p>
          </section>

          <section>
            <h2 style={{color: '#1e293b'}} className="text-xl font-semibold mb-4">11. Réclamation</h2>
            <p style={{color: '#475569'}}>
              Si vous estimez que vos droits ne sont pas respectés, vous pouvez introduire une réclamation 
              auprès de la CNIL (Commission Nationale de l'Informatique et des Libertés) : <a href="https://www.cnil.fr" className="text-blue-600 hover:underline" target="_blank" rel="noopener noreferrer">www.cnil.fr</a>
            </p>
          </section>

          <section>
            <h2 style={{color: '#1e293b'}} className="text-xl font-semibold mb-4">12. Modifications</h2>
            <p style={{color: '#475569'}}>
              Cette politique peut être mise à jour. En cas de modification substantielle, 
              nous vous en informerons par email ou notification sur le service.
            </p>
          </section>

          <p style={{color: '#94a3b8'}} className="text-sm mt-8">
            Dernière mise à jour : Février 2026
          </p>
        </div>
      </main>
    </div>
  );
};

export default ConfidentialitePage;
